import Vue from 'vue';
import {
  mapGetters,
  mapState
} from 'vuex';
import {
  URL,
  ProjectSettings
} from '../../config/env'

export {
  Vue,
  mapGetters,
  mapState,
  URL,
  ProjectSettings
}



// WEBPACK FOOTER //
// ./src/views/base/base.js